import { Directive, ElementRef, HostListener, ComponentFactoryResolver, ComponentRef, ViewContainerRef, Input, Renderer2, TemplateRef } from '@angular/core';
import { PopoverComponent } from './popover.component';

@Directive({
  selector: '[appPopover]'
})
export class PopoverDirective {
  @Input() popoverTemplate: TemplateRef<any> | null = null;
  @Input() popoverTitle: string = '';
  @Input() popoverPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';

  private popoverRef: ComponentRef<PopoverComponent> | null = null;

  constructor(
    private elementRef: ElementRef,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private renderer: Renderer2
  ) {}

  @HostListener('click')
  togglePopover() {
    if (this.popoverRef) {
      this.closePopover();
    } else {
      this.openPopover();
    }
  }

  openPopover() {
    if (!this.popoverTemplate) return;

    const factory = this.componentFactoryResolver.resolveComponentFactory(PopoverComponent);
    this.popoverRef = this.viewContainerRef.createComponent(factory);
    this.popoverRef.instance.title = this.popoverTitle;
    this.popoverRef.instance.template = this.popoverTemplate;
    this.popoverRef.instance.position = this.popoverPosition;
    this.popoverRef.instance.isOpen = true;

    // Delay the positioning to ensure content is rendered
    setTimeout(() => {
      const popoverElement = this.popoverRef?.instance.popoverContent.nativeElement;
      this.positionPopover(popoverElement);
      this.renderer.setStyle(popoverElement, 'visibility', 'visible');  // Make visible after positioning
    }, 0);  // Wait for a tick for the content to be rendered

    // Listen for outside clicks
    this.renderer.listen('document', 'click', this.handleOutsideClick.bind(this));
  }

  closePopover() {
    if (this.popoverRef) {
      this.popoverRef.instance.isOpen = false;
      this.popoverRef.destroy();
      this.popoverRef = null;
    }
  }

  handleOutsideClick(event: Event) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    const clickedInsidePopover = this.popoverRef?.location.nativeElement.contains(event.target);

    if (!clickedInside && !clickedInsidePopover) {
      this.closePopover();
    }
  }

  positionPopover(popoverEl: HTMLElement) {
    const hostElPosition = this.elementRef.nativeElement.getBoundingClientRect();

    const popoverHeight = popoverEl.offsetHeight;
    const popoverWidth = popoverEl.offsetWidth;

    switch (this.popoverPosition) {
      case 'top':
        this.renderer.setStyle(popoverEl, 'left', `${hostElPosition.left + hostElPosition.width / 2 - popoverWidth / 2}px`);
        this.renderer.setStyle(popoverEl, 'top', `${hostElPosition.top - popoverHeight}px`);
        break;
      case 'bottom':
        this.renderer.setStyle(popoverEl, 'left', `${hostElPosition.left + hostElPosition.width / 2 - popoverWidth / 2}px`);
        this.renderer.setStyle(popoverEl, 'top', `${hostElPosition.top + hostElPosition.height}px`);
        break;
      case 'left':
        this.renderer.setStyle(popoverEl, 'left', `${hostElPosition.left - popoverWidth}px`);
        this.renderer.setStyle(popoverEl, 'top', `${hostElPosition.top + hostElPosition.height / 2 - popoverHeight / 2}px`);
        break;
      case 'right':
        this.renderer.setStyle(popoverEl, 'left', `${hostElPosition.left + hostElPosition.width}px`);
        this.renderer.setStyle(popoverEl, 'top', `${hostElPosition.top + hostElPosition.height / 2 - popoverHeight / 2}px`);
        break;
    }
  }
}
